import { CancelTokenSource } from 'axios';
import {
  TBoardDetail,
  TCreateBoardDetail,
  TUpdateBoardDetail,
  TBoardComment,
  TCreateBoardComment,
  TUpdateBoardComment,
} from 'modules/board';
import { TListRequestParams, TListResponse } from 'modules/types';
import { EBoardType } from 'enums/base.enum';
import apiClient from './apiClient';

/*
 * CSLab content Board
 */
export const getBoard = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TBoardDetail>(`/board/cslab/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const createBoard = (params: TCreateBoardDetail, cancel?: CancelTokenSource) => {
  return apiClient.post('/board/cslab', params, {
    cancelToken: cancel?.token,
  });
};

export const updateBoard = (id?: number, params?: TUpdateBoardDetail, cancel?: CancelTokenSource) => {
  return apiClient.put(`/board/cslab/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

export const deleteBoard = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.delete(`/board/cslab/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const getBoards = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TBoardDetail>>(`/board/cslabs`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

/*
 * CSWebinar Board
 */
export const getWebinar = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TBoardDetail>(`/board/webinar/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const createWebinar = (params: TCreateBoardDetail, cancel?: CancelTokenSource) => {
  return apiClient.post('/board/webinar', params, {
    cancelToken: cancel?.token,
  });
};

export const updateWebinar = (id?: number, params?: TUpdateBoardDetail, cancel?: CancelTokenSource) => {
  return apiClient.put(`/board/webinar/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

export const deleteWebinar = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.delete(`/board/webinar/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const getUpcomingWebinars = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TBoardDetail>>(`/board/upcoming_webinars`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getPastWebinars = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TBoardDetail>>(`/board/past_webinars`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

/*
 * 댓글
 */
export const getBoardComments = (
  id: number,
  boardType: EBoardType,
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get<TListResponse<TBoardComment>>(`/board/${id}/comments`, {
    params: { ...params, board_type: boardType },
    cancelToken: cancel?.token,
  });
};

export const createBoardComment = (id: number, params: TCreateBoardComment, cancel?: CancelTokenSource) => {
  return apiClient.post(`/board/${id}/comment`, params, {
    cancelToken: cancel?.token,
  });
};

export const getBoardComment = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TBoardComment>(`/board/comment/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const updateBoardComment = (id?: number, params?: TUpdateBoardComment, cancel?: CancelTokenSource) => {
  return apiClient.put(`/board/comment/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

export const deleteBoardComment = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.delete(`/board/comment/${id}`, {
    cancelToken: cancel?.token,
  });
};
